import { EmptyDate } from '@cbgms/base/utils/datetime'

export const requiredDate = (value?: string) => {
  return value === '' || value === null || value === undefined || value === EmptyDate ? 'global.field_is_required' : undefined
}
